import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/**
 * キャッシュバック受取登録フォームの入力データ型。
 * 外部口座登録画面へ進む前に、口座コードと名義人カナを一時保持するために使う。
 */
type CashbackRegisterForm = {
  /** 口座番号 */
  code: string;
  /** 口座名義人（カナ） */
  nameKn: string;
};
export type { CashbackRegisterForm };

/**
 * キャッシュバック受取登録入力を保持する state。
 * 確認や外部画面遷移をまたいでも入力内容を失わないよう、セッションへ保持する。
 */
const CashbackRegisterFormState = atom<CashbackRegisterForm>({
  key: 'cashbackRegisterForm',
  default: {
    code: '',
    nameKn: '',
  },
  effects_UNSTABLE: [persistAtom],
});
export { CashbackRegisterFormState };
